import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Register from '../views/Register.vue';
import Login from '../views/Login.vue';
import User from '../views/User.vue';
import About from '../views/About.vue';
import store from '../store';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: '首页'
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        meta: {
            title: '注册'
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: '登录'
        }
    },
    {
        path: '/user',
        name: 'User',
        component: User,
        meta: {
            title: '用户中心',
            requiresAuth: true //需要登录认证的路由
        } 
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: '关于我们'
        }
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),// 使用 history 模式，配合解决线上部属时路由页面刷新404问题
    routes
});

// 定义网站名称
const siteName = '网站开发学习测试';

// 设置全局前置守卫
router.beforeEach((to, from, next) => {
    // 检查 token 是否存在
    const token = localStorage.getItem('token');
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!token) {
            next('/login');
            return; // 如果重定向到登录页面，就不需要执行后面的代码了
        }
    }

    // 检查 token 是否过期
    const tokenExpiration = localStorage.getItem('tokenExpiration');
    const now = Date.now();
    if (tokenExpiration && now > tokenExpiration) {
        // 如果 token 过期，清除 token 并重定向到登录页面
        console.log(tokenExpiration,'前置守卫这里过期了');
        localStorage.removeItem('token');
        localStorage.removeItem('tokenExpiration');
        localStorage.removeItem('userName');

        // 提交 mutation 来更新登录状态
        store.commit('setLoggedIn', { isLoggedIn: false, userName: '' });

        // 如果用户正在访问 User 页面，重定向到登录页面
        if (to.name === 'User') {
            next('/login');
            return;
        }
    }

    // 如果路由有 meta 属性并且 meta 属性有 title 属性
    if (to.meta && to.meta.title) {
        console.log(to.meta.title);
        // 更新页面标题
        document.title = `${to.meta.title} - ${siteName}`;
    } else {
        // 如果没有设置路由标题，则只显示网站名称
        document.title = siteName;
    }

    next();
});

export default router;